<template>
<nav class="routine_finder__step">
    <span class="step_line"></span>
    <ul class="routine_finder__step__list" ref="stepNav">
        <li class="routine_finder__step__list__item" v-for=" n in getQuestionCount" :key="n"><button :class="['stepBtn', getCurrentIndex === n - 1 ? '--active' : getCurrentIndex < n - 1 ? '' : '--previous']">
                <span class="qa_number">{{ n }}<span class="tick"></span>
                </span>
                <span  class="qa_title" :data-title="getQuestionList[n - 1].category">
                </span>
              
            </button></li>
    </ul>
</nav>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import {
    truncateRichText
} from '@Foundation/directives/truncateRichText/truncateRichText';
export default {
    name: 'routine-finder-nav-step',
    directives: {
        truncateRichText
    },
    data() {
        return {
            getInnerText: '',
            smallScreen: !window.matchMedia('(min-width: 1024px)').matches,
        }
    },
    computed: {
        ...mapGetters(['getQuestionCount', 'getQuestionList', 'getAnswerDataList', 'getCurrentIndex']),
    },
    mounted() {
        this.hyphenchange()

    },
    methods: {
        hyphenchange() {
            const navStepItems = this.$refs.stepNav.querySelectorAll('.routine_finder__step__list__item .qa_title');
            if (navStepItems) {
                navStepItems.forEach((item) => {
                    let textWithBreaks = this.smallScreen ? item.getAttribute('data-title').replace(/-/g, '<br>') : item.getAttribute('data-title').replace(/-/g, '');
                    const limit = 30;
                    let count = 0;
                    let result = '';
                    let done = false;

                    const segments = textWithBreaks.split(/(<br\s*\/?>)/gi);

                    segments.forEach(segment => {
                        if (done) return;

                        if (/<br\s*\/?>/i.test(segment)) {
                            result += segment;
                        } else {
                            const remaining = limit - count;
                            if (remaining <= 0) {
                                done = true;
                                return;
                            }
                            const sliced = segment.slice(0, remaining);
                            result += sliced;
                            count += sliced.length;
                            if (count >= limit) done = true;
                        }
                    });
                    return item.innerHTML = result
                });
            }

        }
    }
};
</script>

<style lang="scss" src="./routine-finder-navi-step.scss"></style>
